exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".StickyButton{color:white;font-size:2rem;font-weight:100;line-height:5rem;position:absolute;top:70%;right:45%;z-index:2;border-bottom:1px #adeeff solid;cursor:pointer}@media only screen and (max-width: 650px){.StickyButton{top:80%;right:35%}}\n", ""]);
